import React, { Component } from "react";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";
import { connect } from "react-redux";

import { media } from "utils/style";
import { checkNestedObject } from "utils/checkNestedObject";

import StyledLink from "common-components/StyledLink";
import Container from "common-components/Container";

class ResendPasswordSuccess extends Component {
  render() {
    const { pageContent } = this.props;
    const to = checkNestedObject(this.props, "location", "state", "returnRoute")
      ? this.props.location.state.returnRoute
      : "your-data";

    return (
      <Container>
        <H1>{convertStringToElements(pageContent.section_title)}</H1>
        <P>{pageContent.section_description}</P>
        <StyledLink background={pageContent.buttons[0].type} to={to}>
          {pageContent.buttons[0].text}
        </StyledLink>
      </Container>
    );
  }
}

const mapStateToProps = ({ pageContent: { resend_password: pageContent } }) => ({ pageContent });

export default connect(mapStateToProps)(ResendPasswordSuccess);

const H1 = styled.h1`
  font-size: 32px;
  line-height: 30px;
  margin-bottom: 20px;
  max-width: 396px;

  ${media.mobile`
    font-size: 25px;	
    line-height: 24px;
  `}
`;

const P = styled.p`
  margin-bottom: 40px;
`;
